import './EditDropdownMenu.scoped.sass'
import { AddLabelModalContainer } from '../../../../BoxesMenu/components/AddBoxLabelButton/AddBoxLabelModalContainer/AddBoxLabelModalContainer'

import { ReactComponent as PencilIcon } from '@/assets/icons/pencil-icon-2.svg'
import { ReactComponent as EyeOffIcon } from '@/assets/icons/eye-off-solid.svg'
import { ReactComponent as EyeOnIcon } from '@/assets/icons/eye-on-solid.svg'

import { ReactComponent as TrashIcon } from '@/assets/icons/trash-icon-2.svg'
import modalService from '@/services/modal.service'
import labelsService from '@/app-domains/labels/labels.service'
import { useEffect } from 'react'
import dropdownService from '@/components/DropdownMenu/dropdown.service'
import threadsService from '@/app-domains/threads/threads.service'
import sessionService from '@/app-domains/user/session/session.service'
import { ReactComponent as ChevronUp } from '@/assets/icons/editor/chevron-up.svg'
import { ReactComponent as ChevronDown } from '@/assets/icons/chevron-down.svg'

export function EditDropdownMenu ({ label, event, maxLabelOrder }) {
  const iconSize = { width: '18px', height: '18px' }
  const menuOptions = [
    label.role !== 'default'
      ? {
          icon: <PencilIcon style={iconSize} />,
          title: 'Edit',
          action: () => {
            dropdownService.close()
            modalService.open(<AddLabelModalContainer label={label} closeAddLabelModal={() => modalService.close()} />)
          },
          color: 'normal',
        }
      : null,
    {
      icon: label.showninfeed || (label.type === 'no-labeled' && sessionService.hasUnlabeledVisible()) ? <EyeOffIcon style={iconSize} /> : <EyeOnIcon style={iconSize}/>,
      title: label.showninfeed || (label.type === 'no-labeled' && sessionService.hasUnlabeledVisible()) ? 'Hide in All' : 'Show in All',
      action: () => {
        dropdownService.close()
        labelsService.hideLabelFromMainFeed(label)
      },
      color: 'normal'
    },
    label.role !== 'default'
      ? {
          separator: true
        }
      : null,
    label.sortindex > 0 && {
      icon: <ChevronUp style={iconSize}/>,
      title: 'Move Up',
      action: () => {
        dropdownService.close()
        labelsService.resortLabelToIndex(label, label.sortindex - 1)
      },
      color: 'normal'
    },
    label.sortindex < maxLabelOrder && {
      icon: <ChevronDown style={iconSize}/>,
      title: 'Move Down',
      action: () => {
        dropdownService.close()
        labelsService.resortLabelToIndex(label, label.sortindex + 1)
      },
      color: 'normal'
    },
    label.role !== 'default'
      ? {
          separator: true
        }
      : null,
    label.role !== 'default'
      ? {
          icon: <TrashIcon style={iconSize} />,
          title: 'Delete',
          action: () => {
            dropdownService.close()
            labelsService.deleteLabel(label.composedid)
              .then(() => {
                // TODO: Move this logic to threads service
                if (threadsService.getCurrentFilter().type === 'Label') {
                  if (threadsService.getCurrentFilter().value === label.composedid) {
                    threadsService.applyFilterFor('all', 'All messages', 'all', true)
                  }
                }
              })
              .catch((err) => {
                throw new Error(err)
              })
          },
          color: 'red'
        }
      : null,
  ].filter(option => option)

  useEffect(() => {
    dropdownService.open(menuOptions, 'right', event)
  }, [])

  return <></>
}
